module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.selectedSubject === undefined) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.defaultSubject),
      expression: "defaultSubject"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "subject_id",
      "required": "required"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.defaultSubject = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onSubjectChange($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": "0"
    }
  }, [_vm._v("Chọn")]), _vm._l((_vm.filterSubject), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "subject_id",
      "required": "required"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.onSubjectChange($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "disabled",
      "value": "0"
    }
  }, [_vm._v("Chọn")]), _vm._l((_vm.filterSubject), function(o) {
    return _c('option', {
      domProps: {
        "value": o.id
      }
    }, [_vm._v(_vm._s(o.name))])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b58da8a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/itemSubject.vue
// module id = 1480
// module chunks = 0